import { render } from "./Button.vue?vue&type=template&id=aa914c5c"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/space/grid/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa914c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa914c5c', __exports__)) {
    api.reload('aa914c5c', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=aa914c5c", () => {
    api.rerender('aa914c5c', render)
  })

}


export default __exports__